import { render, staticRenderFns } from "./skeleton_loading_container.vue?vue&type=template&id=993aae32"
import script from "./skeleton_loading_container.vue?vue&type=script&lang=js"
export * from "./skeleton_loading_container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports